module.exports = "/images/vendor/flag-icon-css/flags/1x1/bw.svg?d9e5e45f7cabb9c0790ba95948c30609";